import { render, staticRenderFns } from "./VCardVenda.vue?vue&type=template&id=226fc63d"
import script from "./VCardVenda.vue?vue&type=script&lang=js"
export * from "./VCardVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports